import { ContinueButton, RequiredNote } from './common.jsx';

// Repeatable free-text entries (e.g. surgeries: "what + roughly when", add another).
// Stored as an array under the follow-up's field id; joined to a single string on submit.
export default function RepeatGroup({ fu, answers, setAnswer, onAdvance }) {
  const entries = Array.isArray(answers[fu.id]) ? answers[fu.id] : [''];
  // Shown only when the parent is Yes, so a required roll-up needs one real entry.
  const incomplete = fu.required_when_shown && !entries.some((e) => (e || '').trim());

  const update = (i, v) => {
    const next = entries.slice();
    next[i] = v;
    setAnswer(fu.id, next);
  };
  const add = () => setAnswer(fu.id, [...entries, '']);

  return (
    <div>
      <p className="sub" style={{ margin: '18px 0 8px' }}>{fu.label}</p>
      {entries.map((val, i) => (
        <div className="ecard" key={i}>
          <textarea
            className="ta"
            style={{ minHeight: 64 }}
            value={val}
            placeholder="e.g. Gallbladder removal, ~2019"
            onChange={(e) => update(i, e.target.value)}
          />
        </div>
      ))}
      <button className="addb" onClick={add}>+ Add another</button>
      {incomplete && <RequiredNote textAnswer />}
      <div className="spacer" style={{ height: 14 }} />
      <ContinueButton onClick={onAdvance} disabled={incomplete} />
    </div>
  );
}
